import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { initialStates } from '../initialStates';
import { combineForms } from 'react-redux-form';
import storeReducer from './storeReducer';
import hoAccountsReducer from './hoAccountsReducer';
import assessmentsReducer from './assessmentsReducer';
import accountManagersReducer from './accountManagersReducer';
import userReducer from './userReducer';
import { resetStateReducer,
  verifyReducer,
  questionsReducer,
  answersReducer,
  newPasswordReducer,
  verifyResetLinkReducer
} from './resetReducer';
import viewReducer from './viewReducer';
import staffReducer from './staffReducer';
import aboutYouReducer from './aboutYouReducer';
import storeDetailReducer from './storeDetailReducer';
import registrationReducer from './registrationReducer';
import userGroupsReducer from './userGroupsReducer';
import usersReducer from './usersReducer';
import notificationsReducer from './notificationsReducer';
import pagesReducer from './pagesReducer';
import customerNumberReducer from './customerNumberReducer';
import storeDelinkReducer from './storeDelinkReducer';
import logoutReducer from './logoutReducer';
import welcomeReducer from './welcomeReducer';
import { categoriesReducer, brandsReducer, productsReducer, groupSelectorReducer }  from './productsReducer';
import { promotionsReducer }  from './promotionsReducer';
import { promotionalBannersReducer }  from './promotionalBannersReducer';
import { upsellPopupsReducer }  from './upsellPopupsReducer';
import ordersReducer from './ordersReducer';
import orderLimitsReducer from './orderLimitsReducer';
import dataExportsReducer from './dataExportsReducer';
import dataImportsReducer from './dataImportReducer';
import templateReducer from './templateReducer';
import ppcReducer from './ppcReducer';
import pointsReducer from './pointsReducer';
import pointsStatementReducer from './pointsStatementReducer';
import incentivesReducer from './incentivesReducer';
import voucherReducer from './voucherReducer';
import {newsCategoriesReducer, newsArticlesReducer }  from './newsReducer';
import contentReducer from './contentReducer';
import homeReducer from './homeReducer';
import aboutIgniteReducer from './aboutIgniteReducer';
import latestNewsReducer from './latestNewsReducer';
import articleReducer from './articleReducer';
import messagesReducer from './messagesReducer';
import filesReducer from './filesReducer';
import groupReducer from './groupsReducer';
import privacyPolicyReducer from './privacyPolicyReducer';
import samlReducer from './samlReducer';
import featuresReducer from './featuresReducer';
import prizesReducer from './prizesReducer';
import stockNotificationsReducer from './stockNotificationsReducer';
import incentivePerformancesReducer from './incentivePerformancesReducer';
import outletRewardAllocationsReducer from './outletRewardAllocationsReducer';
import stockItIncentivesReducer from './stockItIncentivesReducer';
import featuresTogglesReducer from './featureTogglesReducer';
import rewardsReducer from './rewardsReducer';
import gamesReducer from './gamesReducer';

export default combineReducers({
  router: routerReducer,
  viewConfig: viewReducer,
  stores: storeReducer,
  assessments: assessmentsReducer,
  hoAccounts: hoAccountsReducer,
  accountManagers: accountManagersReducer,
  delink: storeDelinkReducer,
  currentUser: userReducer,
  resetState: resetStateReducer,
  newPasswordState: newPasswordReducer,
  verifyResetLink: verifyResetLinkReducer,
  verifyPIN: verifyReducer,
  questions: combineReducers({
    questions: questionsReducer,
    answers: answersReducer
  }),
  welcome: welcomeReducer,
  staff: staffReducer,
  aboutYou: aboutYouReducer,
  store: storeDetailReducer,
  customer_numbers: customerNumberReducer,
  registration: registrationReducer,
  userGroups: userGroupsReducer,
  users: usersReducer,
  logout: logoutReducer,
  notifications: notificationsReducer,
  orders: ordersReducer,
  pages: pagesReducer,
  data_exports: dataExportsReducer,
  data_imports: dataImportsReducer,
  categories: categoriesReducer,
  brands: brandsReducer,
  products: productsReducer,
  groupSelector: groupSelectorReducer,
  promotions: promotionsReducer,
  promotionalBanners: promotionalBannersReducer,
  upsellPopups: upsellPopupsReducer,
  orderLimits: orderLimitsReducer,
  templates: templateReducer,
  ppc: ppcReducer,
  points: pointsReducer,
  points_statement: pointsStatementReducer,
  incentives: incentivesReducer,
  incentivePerformances: incentivePerformancesReducer,
  voucher: voucherReducer,
  home: homeReducer,
  aboutIgnite: aboutIgniteReducer,
  latestNews: latestNewsReducer,
  article: articleReducer,
  news: combineReducers({
    categories: newsCategoriesReducer,
    articles: newsArticlesReducer,
  }),
  content: contentReducer,
  messages: messagesReducer,
  files: filesReducer,
  groups: groupReducer,
  privacyPolicy: privacyPolicyReducer,
  saml: samlReducer,
  deep: combineForms(initialStates, 'deep'),
  features: featuresReducer,
  featureToggles: featuresTogglesReducer,
  prizes: prizesReducer,
  stockNotifications: stockNotificationsReducer,
  outletRewardAllocations: outletRewardAllocationsReducer,
  stockItIncentives: stockItIncentivesReducer,
  rewards: rewardsReducer,
  games: gamesReducer
});



// WEBPACK FOOTER //
// ./src/reducers/index.js